import { render, staticRenderFns } from "./SellModal.vue?vue&type=template&id=2cb6109a&scoped=true"
import script from "./SellModal.vue?vue&type=script&lang=js"
export * from "./SellModal.vue?vue&type=script&lang=js"
import style0 from "./SellModal.vue?vue&type=style&index=0&id=2cb6109a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6109a",
  null
  
)

export default component.exports